<template>
  <div :style="getStyle(data?.style)" @mouseleave="isContainerActive = false">
    <div v-if="!placeholdersEnabled">
    <div class="dynamicIcon"  @click.stop="shareProps(blockId, emailData[blockId]); isContainerActive = true; currentDiv = childId">
        <span class="material-symbols-outlined">dynamic_form</span>
      </div>
    <div v-if="hasChildren">
      <div
        @mousemove="checkProximity($event, childId), currentDivHover = childId"
        @mouseleave="resetProximity"
        v-for="childId in data?.props?.childrenIds"
        :key="childId"
        class="component"
      >
        <component
          :is="getComponentType(emailData[childId]?.type)"
          :data="emailData[childId]?.data"
          :emailData="emailData"
          :blockId="childId"
          @click.stop="shareProps(childId, emailData[childId]); isContainerActive = true, currentDiv = childId"
        ></component>
        <div v-if="isContainerActive  && currentDiv == childId" class="delete-button" @click.stop="deleteBlock(childId)">
          <span class="material-symbols-outlined">delete</span>
        </div>
        <div
          v-if="isNearTopButton && currentDivHover == childId"
          class="container-addButton top"
          @click.stop.self="toggleAddList($event, 'top', childId)"
        >+</div>
        <div
          v-if="isNearBottomButton  && currentDivHover == childId"
          class="container-addButton bottom"
          @click.stop.self="toggleAddList($event, 'bottom', childId)"
        >+</div>
      </div>
      <AddList
        v-if="showAddList && activeButtonId === activeButtonId"
        :style="addListStyle"
        :clicked = clicked
        :parentType = "'Container'"
        :parentId="activeChildComponent"
        :blockId="blockId"
        @close="closeAddList"
        @add-blockCo="addBlockContainer"
        ref="addList"
      />
    </div>
    <EmptyBlock
      v-if="currentView === 'Edit' && !hasChildren"
      :parentId="blockId"
      :parentType="'Container'"
      @showAddList="showAddList($event, 'container', data)"
    />
  </div>
  <div v-else>
      <div
        v-for="(node, index) in dynamicNodes"
        :key ="index"
      >
      <div v-if="hasChildren">
      <div
        @mousemove="checkProximity($event, childId), currentDivHover = childId"
        @mouseleave="resetProximity"
        v-for="childId in data?.props?.childrenIds"
        :key="childId"
        class="component"
      >
        <component
          :is="getComponentType(emailData[childId]?.type)"
          :data="emailData[childId]?.data"
          :emailData="emailData"
          :dynamicIndex ="index"
          :blockId="childId"
          @click.stop="shareProps(childId, emailData[childId]); isContainerActive = true, currentDiv = childId"
        ></component>
        <div v-if="isContainerActive  && currentDiv == childId" class="delete-button" @click.stop="deleteBlock(childId)">
          <span class="material-symbols-outlined">delete</span>
        </div>
        <div
          v-if="isNearTopButton && currentDivHover == childId"
          class="container-addButton top"
          @click.stop.self="toggleAddList($event, 'top', childId)"
        >+</div>
        <div
          v-if="isNearBottomButton  && currentDivHover == childId"
          class="container-addButton bottom"
          @click.stop.self="toggleAddList($event, 'bottom', childId)"
        >+</div>
      </div>
      <AddList
        v-if="showAddList && activeButtonId === activeButtonId"
        :style="addListStyle"
        :clicked = clicked
        :parentType = "'Container'"
        :parentId="activeChildComponent"
        :blockId="blockId"
        @close="closeAddList"
        @add-blockCo="addBlockContainer"
        ref="addList"
      />
    </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EmptyBlock from './EmptyBlock.vue';
import HtmlBlock from './HtmlBlock.vue';
import HeadingBlock from './HeadingBlock.vue';
import TextBlock from './TextBlock.vue';
import SpacerBlock from './SpacerBlock.vue';
import ImageBlock from './ImageBlock.vue';
import ButtonBlock from './ButtonBlock.vue';
import DividerBlock from './DividerBlock.vue';
import ColumnsContainerBlock from './ColumnsContainerBlock.vue';
import ContainerBlock from './ContainerBlock.vue';
import RulesetBlock from './RulesetBlock.vue';
import QrBlock from './QrBlock.vue';
import AddList from '../Reusables/AddList.vue';
import { getXmlValueByPath } from '@/utils/getXmlValueByPath';

export default {
  name: 'DynContainerBlock',
  components: {
    EmptyBlock,
    AddList,
  },
  props: {
    data: Object,
    emailData: Object,
    blockId: String, //ID of the rendered container, props form Preview.vue
  },
  data() {
    return {
      showAddButton: false,
      showAddList: false,
      addListStyle: {},
      activeChildComponent: null, //stores Id of Child Component, where the AddList was triggered from
      isContainerActive: false,
      isNearTopButton: false,
      isNearBottomButton: false,
      clicked: 'container', //type of the clicked component
      position: 'bottom',
      currentDiv: '', //stores the clicked div ID
      currentDivHover: '', //stores the currently hovered div
      dynamicNodes: []  // Hier speichern wir den Array der Knoten
    };
  },
  computed: {
    ...mapGetters(['getView', 'getPlaceholdersEnabled']),
    currentView() {
      return this.getView;
    },
    hasChildren() {
      return this.data?.props?.childrenIds?.length > 0;
    },
    placeholdersEnabled(){
        return this.getPlaceholdersEnabled
      }
    
  },
  methods: {
    ...mapActions(['updateSharedData', 'removeBlock', 'addNewBlock']),
    getStyle(style) {
      let border;
      const backgroundColor = style?.backgroundColor || null;
      if (style?.borderColor && style?.borderColor != null) {
        border = `${style?.borderColor} ${style?.borderWidth || 1 }px solid` || null;
      }
      const borderRadius = `${style?.borderRadius}px` || null;
      let width;
      if (style?.width == 'inherit') {
        width = 'inherit';
      } else {
        width = `${style?.width}px` || 'inherit';
      }
      let height;
      if (style?.height == 'auto') {
        height = 'auto';
      } else {
        height = `${style?.height}px` || 'auto';
      }
      const padding = style?.padding
        ? `${style.padding.top}px ${style.padding.right}px ${style.padding.bottom}px ${style.padding.left}px`
        : '0';
      /* const margin = style?.margin 
        ? `0px ${style.margin.right}px 0px ${style.margin.right}px`
        : '0 auto' */ 
      if(style?.position) {
        const position = style.position 
        const left = `${style.direction.left}px`;
        const top = `${style.direction.top}px`;
        return {
          backgroundColor: backgroundColor,
          border: border,
          borderRadius: borderRadius,
          padding: padding,
          width: width,
          height: height,
          position: position,
          left: left,
          top: top,
       /*  margin: margin */
      }} else {
        return {
          backgroundColor: backgroundColor,
          border: border,
          borderRadius: borderRadius,
          padding: padding,
          width: width,
          height: height
       /*  margin: margin */
      }};
    },
    getComponentType(type) {
      const components = {
        Heading: HeadingBlock,
        HtmlBlock: HtmlBlock,
        Text: TextBlock,
        Spacer: SpacerBlock,
        Image: ImageBlock,
        Container: ContainerBlock,
        Button: ButtonBlock,
        Divider: DividerBlock,
        ColumnsContainer: ColumnsContainerBlock,
        Qr: QrBlock,
        Ruleset: RulesetBlock,
      };
      return components[type] || 'div';
    },
    shareProps(childId, data) {
      this.updateSharedData({id: childId, data});
    },
    toggleAddList(event, position, childId) {
      event.stopPropagation();
      this.activeChildComponent = childId;
      this.position = position;
      this.activeButtonId = childId; // Set the active button ID
      const buttonRect = event.target.getBoundingClientRect();
      const parentRect = event.target.parentElement.getBoundingClientRect();
      const top = position === 'top' ? buttonRect.top - parentRect.top : buttonRect.bottom - parentRect.top;
      const left = buttonRect.left - parentRect.left;

      this.addListStyle = {
        top: `${top}px`,
        left: `${left}px`,
        transform: 'translateY(20px)', // adjust as needed
        position: 'absolute',
        zIndex: 10,
      };
      this.showAddList = true;
      document.addEventListener('click', this.handleClickOutside);
    },
    handleClickOutside(event) {
      const addListElement = this.$refs.addList?.$el;
      if (this.showAddList && addListElement && !addListElement.contains(event.target)) {
        this.closeAddList();
      }
    },
    closeAddList() {
      this.showAddList = false;
      this.activeButtonId = null;
      document.removeEventListener('click', this.handleClickOutside);
    },
    addBlockContainer(type) {
      console.log('test', this.blockId)
      this.addNewBlock({
        type: type,
        targetId: this.activeChildComponent,
        position: this.position,
        parentId: this.blockId,
        parentType: 'Container'
      });
      this.showAddList = false;
    },
    deleteBlock(childId) {
      this.removeBlock({ parentId: this.blockId, parentType: 'Container', blockId: childId });
    },
    checkProximity(event, childId) {
      const rect = event.currentTarget.getBoundingClientRect();
      const mouseY = event.clientY;
      const mouseX = event.clientX;

      // Check if the mouse is over any clickable elements within the container
      const elementUnderMouse = document.elementFromPoint(mouseX, mouseY);
      const isInteractiveElement = elementUnderMouse && ['A', 'BUTTON', 'INPUT', 'TEXTAREA', 'SELECT', 'OPTION'].includes(elementUnderMouse.tagName);

      if (!isInteractiveElement) {
        this.isNearTopButton = mouseY >= rect.top - 10 && mouseY <= rect.top + 10 && mouseX >= rect.left && mouseX <= rect.right;
        this.isNearBottomButton = mouseY >= rect.bottom - 10 && mouseY <= rect.bottom + 10 && mouseX >= rect.left && mouseX <= rect.right;
      } else {
        this.isNearTopButton = false;
        this.isNearBottomButton = false;
      }
    },
    resetProximity() {
      this.isNearTopButton = false;
      this.isNearBottomButton = false;
    }
  },
  watch: {
    // Beobachtet den dynamischen Node-Pfad in den Props
    'data.props.dynamicNode': {
      async handler(newVal, oldVal) {
        console.log('test')
        if (newVal) {
          try {
            const result = await getXmlValueByPath(newVal);
            this.dynamicNodes = result;
            console.log('Ergebnis von getXmlValueByPath:', result.length);
          } catch (error) {
            console.error('Fehler beim Aufrufen von getXmlValueByPath:', error);
          }
        }
      },
      immediate: true,  // optional: ruft den Handler auch bei der Initialisierung auf,
      deep: true
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
.component {
  position: relative;
}
.component:hover {
  box-shadow: var(--primary-color) 0px 1px 3px 0px, var(--primary-color) 0px 0px 0px 1px; 
  /* border: 1px solid var(--primary-color); */
}

.container-addButton {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--primary-color);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.clickedAddButton {
  background: var(--secondary-color);
}

.container-addButton.top {
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.container-addButton.bottom {
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.add-list {
  position: absolute;
  z-index: 10;
}

.delete-button {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
  padding: 5px;
  position: absolute;
  top: -10px;
  left: -10px;
  background: white;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 2;
}

.component-container:hover .delete-button {
  opacity: 1;
}

.dynamicIcon{
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: white;
    color: red;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 4px;
    z-index: 100;
    bottom: 0px;
    left: 5px;
    transform: translateX(-50%);
    border: 1px solid white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
  }

  .dynamicIcon:hover{
    border: 1px solid red;
  }
</style>
